import { PropsWithChildren } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { AuthenticationContextWrapper } from './AuthenticationContext'
import SettledPaymentsSurveySignal from './components/invoicing/SettledPaymentsSurveySignal'
import TermsAcceptanceGate from './components/Terms/TermsAcceptanceGate'
import OldVersionWarning from './components/version-check/OldVersionWarning'

const queryClient = new QueryClient()

type Props = {
  $state: any
}

const Root = ({ children, $state }: PropsWithChildren<Props>) => {
  return <QueryClientProvider client={queryClient}>
    <AuthenticationContextWrapper route={$state}>
      <OldVersionWarning />
      <TermsAcceptanceGate />
      <SettledPaymentsSurveySignal />
      {children}
    </AuthenticationContextWrapper>
  </QueryClientProvider>
}

export default Root
